/**
 * All user accounts are currently assumed to be in the same timezone,
 * Brisbane (UTC+10).
 */
export const AccountTimeZone = "Australia/Brisbane";
